import React from 'react';

import styled from 'styled-components';

import ICONS from '../../../../../constants/icons';

import { SummaryItem } from './SummaryItem';

const AampeLogoIcon = styled(ICONS.aampeLogo)({
    height: 16,
    width: 19,
});

const TemplateValue = styled.span({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
});

export const TemplateSummary = ({
    template,
    isCustomTemplate,
}: {
    template?: string;
    isCustomTemplate?: boolean;
}) => {
    return (
        <SummaryItem
            label="Template"
            value={
                <TemplateValue>
                    {template}
                    {isCustomTemplate && <AampeLogoIcon />}
                </TemplateValue>
            }
        />
    );
};
